import React, { useEffect } from 'react';
import { Container, Card, CardContent, Typography, Stack, Button, Box } from '@mui/material';
import { Android, Apple } from '@mui/icons-material';
import { Player } from '@lottiefiles/react-lottie-player';
import confetti from 'canvas-confetti';
import { useTranslation } from 'react-i18next';

const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.safeefr.safee';
const IOS_URL = 'https://apps.apple.com/app/safee/6446244926';

const InviteSuccess: React.FC = () => {
  const { t } = useTranslation();
  const goAndroid = () => window.open(ANDROID_URL, '_blank');
  const goIOS = () => window.open(IOS_URL, '_blank');

  useEffect(() => {
    // Small celebratory confetti burst on mount
    const shoot = () => {
      confetti({ particleCount: 70, spread: 70, origin: { y: 0.6 } });
      setTimeout(() => confetti({ particleCount: 50, spread: 100, origin: { y: 0.4 } }), 250);
    };
    shoot();
  }, []);

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Card elevation={2} sx={{ overflow: 'hidden' }}>
        <Box sx={{ bgcolor: 'background.default', display: 'flex', justifyContent: 'center', pt: 3 }}>
          <Player
            autoplay
            loop
            src="https://assets9.lottiefiles.com/packages/lf20_jbrw3hcz.json"
            style={{ height: 180, width: 180 }}
          />
        </Box>
        <CardContent>
          <Typography variant="h5" fontWeight={800} align="center" gutterBottom>
            {t('inviteSuccess.title')}
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center">
            {t('inviteSuccess.description')}
          </Typography>

          <Stack spacing={2} sx={{ mt: 4 }}>
            <Button
              variant="contained"
              size="large"
              onClick={goAndroid}
              startIcon={<Android />}
            >
              {t('inviteSuccess.downloadAndroid')}
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={goIOS}
              startIcon={<Apple />}
            >
              {t('inviteSuccess.downloadIOS')}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default InviteSuccess;
